// extracted by mini-css-extract-plugin
module.exports = {"headerButton":"EnFaqButton_headerButton__1chgp","faqLink":"EnFaqButton_faqLink__1ufqu"};